/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract IUserDefinedMacro",
                name: "m",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "params",
                type: "bytes",
            },
        ],
        name: "buildBatchOperations",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IUserDefinedMacro",
                name: "m",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "params",
                type: "bytes",
            },
        ],
        name: "runMacro",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MacroForwarder__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
MacroForwarder__factory.bytecode = _bytecode;
MacroForwarder__factory.abi = _abi;
//# sourceMappingURL=MacroForwarder__factory.js.map